import { IReportingTypeService } from "../../service/reporting/ReportingTypeService";
import { IReportingType } from "../../model/reporting/ReportingType";

export default class UpdateReportingTypeInteractor {
  private reportingTypeService: IReportingTypeService;

  constructor(reportingTypeService) {
    this.reportingTypeService = reportingTypeService;
  }

  async execute(reportingType: IReportingType) {
    return this.reportingTypeService.updateReportingType(reportingType);
  }
}
